import * as tslib_1 from "tslib";
import React from 'react';
import { findDOMNode } from 'react-dom';
import getScrollbarSize from 'dom-helpers/util/scrollbarSize';
import MenuList from './MenuList';
import Popover from '../Popover/Popover';
var LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left',
};
export function syncWidth(anchorElement, target) {
    if (target &&
        anchorElement.clientHeight < target.clientHeight &&
        !target.style.width) {
        var size = getScrollbarSize() + "px";
        target.style.paddingRight = size;
        target.style.width = "calc(100% + " + size + ")";
    }
}
/**
 * 菜单组件
 *
 * @ReactComponent
 */
var Menu = /** @class */ (function (_super) {
    tslib_1.__extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getContentAnchorEl = function () {
            if (_this.props.contentAnchorElTarget === 'item') {
                if (!_this.menuList || !_this.menuList.containsSelectedItem) {
                    return findDOMNode(_this.menuList).firstChild;
                }
                return _this.menuList.selectedItem;
            }
            return null;
        };
        _this.menuList = undefined;
        _this.focus = function () {
            if (_this.menuList && _this.menuList.selectedItem) {
                findDOMNode(_this.menuList.selectedItem).focus();
                return;
            }
            if (!_this.props.preventAutoFocus) {
                var menuList = findDOMNode(_this.menuList);
                if (menuList && menuList.firstChild) {
                    menuList.firstChild.focus();
                }
            }
        };
        _this.handleEnter = function (element) {
            var menuList = findDOMNode(_this.menuList);
            // Focus so the scroll computation of the Popover works as expected.
            _this.focus();
            syncWidth(element, menuList);
            if (_this.props.onEnter) {
                _this.props.onEnter(element);
            }
        };
        _this.handleListKeyDown = function (event, key) {
            if (key === 'tab') {
                event.preventDefault();
                if (_this.props.onRequestClose) {
                    _this.props.onRequestClose();
                }
            }
        };
        return _this;
    }
    Menu.prototype.componentDidMount = function () {
        if (this.props.open) {
            this.focus();
        }
    };
    Menu.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.open !== this.props.open && this.props.open) {
            this.focus();
        }
    };
    Menu.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, menuListProps = _a.MenuListProps, onEnter = _a.onEnter, _b = _a.PaperProps, paperProps = _b === void 0 ? {} : _b, paperRef = _a.paperRef, minWidth = _a.minWidth, other = tslib_1.__rest(_a, ["children", "MenuListProps", "onEnter", "PaperProps", "paperRef", "minWidth"]);
        var PaperPropsStyle = paperProps.style || {};
        return (React.createElement(Popover, tslib_1.__assign({ getContentAnchorEl: this.getContentAnchorEl, onEnter: this.handleEnter, anchorOrigin: LTR_ORIGIN, transformOrigin: LTR_ORIGIN, PaperProps: tslib_1.__assign({}, paperProps, { style: tslib_1.__assign({ maxHeight: 'calc(100vh - 96px)', WebkitOverflowScrolling: 'touch', minWidth: minWidth + "px" }, PaperPropsStyle), innerRef: paperRef }) }, other),
            React.createElement(MenuList, tslib_1.__assign({ dense: this.props.dense, role: "menu", onKeyDown: this.handleListKeyDown }, menuListProps, { ref: function (node) {
                    _this.menuList = node;
                }, color: this.props.color, textStyle: this.props.textStyle }), children)));
    };
    Menu.defaultProps = {
        contentAnchorElTarget: 'item',
    };
    return Menu;
}(React.Component));
export default Menu;
//# sourceMappingURL=Menu.js.map